var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"sellers@3528b8657ccaba88e722a64390d1e36ebe6934f6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sellers@riqra-pp"]={id:"sellers@3528b8657ccaba88e722a64390d1e36ebe6934f6"};
      